import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import RefHighlightContainer from '../common/RefHighlightContainer';
import ViewerConditionsGroup from './ViewerConditionsGroup';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerTopLevelLogicGroupItem = props => {
  const {
    logicGroupIndex,
    logicGroup,
    logicOperator,
    matchStatus,
    inputUse
  } = props;
  const {
    viewerClonedGroupIndex,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const onGroupHighlightFinish = useCallback(() => {
    dispatch({
      type: 'viewerClonedGroupIndex',
      payload: undefined
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsxs("div", {
    children: [logicGroupIndex !== 0 && /*#__PURE__*/_jsx(LogicGroupsDivider, {
      logicOperator: logicOperator
    }), /*#__PURE__*/_jsx(RefHighlightContainer, {
      onHighlightFinish: onGroupHighlightFinish,
      shouldHighlight: viewerClonedGroupIndex === logicGroupIndex,
      targetSelector: "[data-highlight-target=\"viewer-conditions-group\"]::before",
      children: /*#__PURE__*/_jsx(ViewerConditionsGroup, {
        inputUse: inputUse,
        logicGroup: logicGroup,
        logicGroupIndex: logicGroupIndex,
        matchStatus: matchStatus
      })
    })]
  });
};
export default ViewerTopLevelLogicGroupItem;